// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"650a62f6","467":"139839a4"}[chunkId] + ".chunk.js";
};